import { Injectable } from "@angular/core";
import { MEMBERS_PP_DIR, team } from '../data/team'
import { ITeamMember } from "../interfaces/team.interface";
@Injectable({
    providedIn: 'root'
})
export class TeamService {

    getTeamMembers(): ITeamMember[] {
        return team.map((tm) => ({ ...tm, profile_picture: `${MEMBERS_PP_DIR}/${tm.profile_picture}` }));
    }

}